/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkingTimeCost } from './WorkingTimeCost';
import {
    WorkingTimeCostFromJSON,
    WorkingTimeCostFromJSONTyped,
    WorkingTimeCostToJSON,
    WorkingTimeCostToJSONTyped,
} from './WorkingTimeCost';

/**
 * 
 * @export
 * @interface CalculateWorkingTimeCostResponse
 */
export interface CalculateWorkingTimeCostResponse {
    /**
     * 
     * @type {WorkingTimeCost}
     * @memberof CalculateWorkingTimeCostResponse
     */
    data: WorkingTimeCost;
}

/**
 * Check if a given object implements the CalculateWorkingTimeCostResponse interface.
 */
export function instanceOfCalculateWorkingTimeCostResponse(value: object): value is CalculateWorkingTimeCostResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CalculateWorkingTimeCostResponseFromJSON(json: any): CalculateWorkingTimeCostResponse {
    return CalculateWorkingTimeCostResponseFromJSONTyped(json, false);
}

export function CalculateWorkingTimeCostResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculateWorkingTimeCostResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': WorkingTimeCostFromJSON(json['data']),
    };
}

  export function CalculateWorkingTimeCostResponseToJSON(json: any): CalculateWorkingTimeCostResponse {
      return CalculateWorkingTimeCostResponseToJSONTyped(json, false);
  }

  export function CalculateWorkingTimeCostResponseToJSONTyped(value?: CalculateWorkingTimeCostResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': WorkingTimeCostToJSON(value['data']),
    };
}

